<div
  class="toast toast-{{type}} mx-auto w-auto"
  role="alert"
  aria-live="assertive"
  aria-atomic="true">
<!--  <div class="toast-header toast-{{type}}">-->
<!--    -->
<!--  </div>-->
  <div class="toast-body d-flex justify-content-between gap-3" style="font-size: 1.1rem">
    <span>{{text}}</span>
    <button
      type="button"
      class="btn-close fs-6"
      aria-label="Close"
      (click)="notificationRef.close()">
    </button>
  </div>
</div>
